module.exports = __webpack_public_path__ + "cf573d6326ac08f466bfa2632c356f7f.jpg";